
/**
 * Determine if we are dealing with a mobile device or not
 * @returns {Boolean}
 */
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? true : false;
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 * ripped straight from SO
 * @returns {String}
 */
export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) return "Windows Phone";
    if (/android/i.test(userAgent)) return "Android";
    // iOS detection, !window.MSStream ensures not IE11
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "iOS";
    return "unknown";
}

/**
 * Determine if this is an iOS device
 * @returns {Boolean}
 */
export function isIos() {
  return (isMobile() && getMobileOperatingSystem() === 'iOS');
}

/**
 * Determine if this is an Android device
 * @returns {Boolean}
 */
export function isAndroid() {
  return (isMobile() && getMobileOperatingSystem() === 'Android');
}
